import _ from "lodash";

export function trimIgnoreNullish<T extends string | null | undefined>(
  value: T,
): T {
  if (typeof value === "string") {
    return _.trim(value) as T;
  }
  return value;
}
